import { createFileRoute, retainSearchParams } from "@tanstack/react-router";
import { useState } from "react";
import { ConfigCodeView } from "../features/customization/components/config-code-overlay";
import { useWidgetConfig } from "../features/customization/hooks/use-widget-config";
import { CustomerSelector } from "../shared/components/customer-selector";
import { Shell } from "../shared/components/shell";
import { ViewToggle } from "../shared/components/view-toggle";
import { Widget } from "../shared/components/widget";

export const Route = createFileRoute("/_layout")({
  component: LayoutComponent,
  search: {
    middlewares: [retainSearchParams(true)],
  },
});

function LayoutComponent() {
  const [showCode, setShowCode] = useState(false);
  const { config } = useWidgetConfig();

  const handleToggleCode = () => {
    setShowCode((prev) => !prev);
  };

  // Runtime detection: Widget-only mode for non-demo customers
  const isWidgetOnly = config.customerId !== "demo";
  // Use import.meta.env for Vite environment detection
  const isDevelopment = import.meta.env.DEV;

  // Check if we're on a demo deployment using baseCustomerId
  // baseCustomerId tells us what the deployment resolves to without overrides
  const baseCustomerId = (config as any).baseCustomerId || config.customerId;
  const isDemoDeployment = baseCustomerId === "demo";

  const shouldShowSelector = isDevelopment || isDemoDeployment;

  // Widget-only mode with customer selector for preview/dev environments
  if (isWidgetOnly && shouldShowSelector) {
    return (
      <div style={{ position: "relative" }}>
        <div
          style={{
            position: "fixed",
            top: 16,
            left: 16,
            zIndex: 1000,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            padding: "8px 12px",
            borderRadius: 8,
          }}
        >
          <CustomerSelector />
        </div>
        <Widget />
      </div>
    );
  }

  // Widget-only mode without selector (production customer deployments)
  if (isWidgetOnly && !shouldShowSelector) {
    return <Widget />;
  }

  // Full demo app: render with Shell and demo components
  return (
    <Shell>
      {showCode ? <ConfigCodeView /> : <Widget />}
      <ViewToggle showCode={showCode} onToggleCode={handleToggleCode} />
    </Shell>
  );
}
